import PropTypes from "prop-types";
import React from "react";

import { Icon } from "@swa-ui/core";
import { classNames } from "@swa-ui/string";

import { FlightTime, flightTimePropTypes } from "../FlightTime";
import styles from "./FlightTimes.module.scss";

/**
 * FlightTimes displays a list of formatted times.
 */
export const FlightTimes = (props) => {
  const { className, flightTimes, separator = <Icon name="Arrow" size="size26" /> } = props;

  return (
    <ul className={classNames(className, styles.flightTimes)}>{flightTimes.map(renderTime)}</ul>
  );

  function renderTime(flightTimeInfo, index) {
    return (
      <React.Fragment key={flightTimeInfo.time}>
        <li>
          <FlightTime {...flightTimeInfo} />
        </li>
        {renderSeparator(flightTimeInfo, index)}
      </React.Fragment>
    );
  }

  function renderSeparator(flightTimeInfo, index) {
    return index < flightTimes.length - 1 ? <li>{separator ? separator : <>&nbsp;</>}</li> : null;
  }
};

FlightTimes.propTypes = {
  /** Additional class to be added to the outermost element for positioning the component. */
  className: PropTypes.string,

  /** Time value to be passed to the component. */
  flightTimes: PropTypes.arrayOf(PropTypes.shape(flightTimePropTypes)),

  /** Content to be rendered between each flight number. */
  separator: PropTypes.node,
};
